<template>
    <div>
        <el-dialog title="修改头像、个人图片、培训照片" :visible.sync="isUpdateShow" width="800px" :close-on-click-modal="false" center>
            <el-form label-width="120px">
                <el-row>
                    <el-col :span="3">头像</el-col>
                    <el-col :span="5">
                        <el-image :preview-src-list="[tempRow.headPic]" :src="tempRow.headPic" style="height:120px" />
                        <input type="file" name="avatar" style="display:none"
                            accept="image/gif, image/jpeg, image/jpg, image/png" @change="changeImage($event)"
                            ref="avatarInput" />
                    </el-col>
                    <el-col :span="3">
                        <el-button type="primary" icon="el-icon-edit" @click="clickHead(1)">选择头像
                        </el-button>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="3">如逸头像</el-col>
                    <el-col :span="5">
                        <el-image :preview-src-list="[tempRow.headPicruyi]" :src="tempRow.headPicruyi" style="height:120px" />
                        <input type="file" name="avatar" style="display:none"
                            accept="image/gif, image/jpeg, image/jpg, image/png" @change="changeImage($event)"
                            ref="avatarInput" />
                    </el-col>
                    <el-col :span="3">
                        <el-button type="primary" icon="el-icon-edit" @click="clickHead(3)">选择头像
                        </el-button>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="3">个人照片<br/>建议尺寸<br/>750*1375</el-col>
                    <el-col :span="20">
                        <el-upload :action="addFile" :on-change="handleOnChange" :file-list="personImageList" :limit="5"
                            :on-exceed="uploadOverrun" :auto-upload="false" :on-remove="handleRemove"
                            accept=".jpg, .jpeg, .png, .gif" list-type="picture-card">
                            <i class="el-icon-plus" />
                        </el-upload>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="3">培训照片</el-col>
                    <el-col :span="5">
                        <el-image :preview-src-list="[tempRow.trainingImg]" :src="tempRow.trainingImg" style="height:120px" />
                        <input type="file" name="avatar" style="display:none"
                            accept="image/gif, image/jpeg, image/jpg, image/png" @change="changeImage($event)"
                            ref="avatarInput" />
                    </el-col>
                    <el-col :span="3">
                        <el-button type="primary" icon="el-icon-edit" @click="clickHead(2)">选择培训照片
                        </el-button>
                    </el-col>
                </el-row>
                <el-row style="color:red;">
                    <center>重新上传后，记得点击下方保存按钮</center>
                </el-row>


            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isUpdateShow = false">关闭</el-button>
                <el-button type="primary" @click="saveupdeate">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import Service from "@/script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";


export default {
    data() {
        return {
            addFile: Service.addFile + globalData.userInfo.userAccount,
            isUpdateShow: false,
            tempRow: {},
            personImageList: [],
            tempType:0,//1头像,2培训图片
        };
    },

    methods: {
        toUpdate(row) {
            this.tempRow = row;
            this.isUpdateShow = true;
            this.personImageList=[];

            if (this.tempRow.personPic && this.tempRow.personPic != null) {
                let arr = this.tempRow.personPic.split(',');
                let that = this;
                arr.forEach(e => {
                    that.personImageList.push({ name: '', url: e });
                });
            }
        },
        saveupdeate() {
            let req = {
                id: this.tempRow.id,
                headPic: this.tempRow.headPic,
                headPicruyi: this.tempRow.headPicruyi,
                personPic: null,
                trainingImg:this.tempRow.trainingImg
            };

            if (this.personImageList.length > 0) {
                let imgs = this.personImageList.map(item => {
                    return item.url;
                });
                req.personPic = imgs.join(',')
            }
            workercrmapi
                .$axiosWorkeUpdateInfo(req)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.isUpdateShow = false;
                        this.$message.success("操作成功");
                        this.$parent.getServantDetail();
                    } else {
                        this.$message.error(res.data.data);
                    }
                });


        },
        
        changeImage(e) {
            var file = e.target.files[0];
            let that = this;
            if (file) {
                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file);
                Service.$ajaxAddFile(param).then((res) => {
                    console.log(res.data.data.fileUrl);
                    if(that.tempType==1){
                        that.tempRow.headPic = res.data.data.fileUrl; 
                    }
                    if(that.tempType==2){
                        that.tempRow.trainingImg = res.data.data.fileUrl; 
                    }
                    if(that.tempType==3){
                        that.tempRow.headPicruyi = res.data.data.fileUrl; 
                    }
                });
            }
        },
        clickHead(type) {
            this.tempType=type;
            this.$refs.avatarInput.click();
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.personImageList = fileList;
        },
        handleOnChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (file.raw) {
                console.log("上传文件大小" + file.raw.size);

                let filesize = Number(file.size / 1024 / 1024);
                if (filesize > 3) {
                    this.$message.error("上传图片不能超过3M,请重新上传");
                    const currIdx = this.personImageList.indexOf(file)
                    this.personImageList.splice(currIdx, 0)
                    return;
                }

                let param = new FormData();
                param.append("createAccount", globalData.userInfo.userAccount);
                param.append("file", file.raw);
                Service.$ajaxAddFile(param).then(res => {
                    console.log(res);
                    if (res.data.errno == 0) {
                        console.log(res);
                        file.url = res.data.data.fileUrl;
                        this.personImageList = fileList;
                        console.log(this.personImageList);
                        //  let url=this.prewWorkerImg(res.data.data.id);
                        //  this.skillImgList.push(res.data.data.fileUrl);
                    }
                });
            }
        },
        uploadOverrun: function () {
            this.$message({
                type: "error",
                message: "上传文件个数超出限制!最多上传5张图片!"
            });
        },
    },
};
</script>
<style>

</style>
